import { render, staticRenderFns } from "./LafiaOptionGroupItem.vue?vue&type=template&id=55f26458&scoped=true"
import script from "./LafiaOptionGroupItem.vue?vue&type=script&lang=js"
export * from "./LafiaOptionGroupItem.vue?vue&type=script&lang=js"
import style0 from "./LafiaOptionGroupItem.vue?vue&type=style&index=0&id=55f26458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f26458",
  null
  
)

export default component.exports